import { createRouter, createWebHistory } from 'vue-router'
import { ref } from 'vue';
import Login from '../views/Login.vue'
import Users from '../views/Users/Users.vue'
import UserDetails from '../views/Users/UserDetails.vue'
import store from '../store'; // Make sure you import your Vuex store
import NotFound from '../views/NotFound.vue'
import Forbidden from '../views/Forbidden.vue';
import VoonixAdvertisers from '../views/VoonixAdvertisers/Index.vue';
import Advertisers from '../views/Advertisers/Index.vue';
import Site from '../views/Sites/Index.vue'
import Home from '../views/Home/Index.vue'
import Settings from '../views/Settings/Index.vue';
import ResetPassword from '../views/ResetPassword.vue';
import AdvertiserEarnings from '@/views/Earnings/Advertiser/AdvertiserEarnings.vue'
import SiteEarnings from '@/views/Earnings/Site/Index.vue';
import Finance from '@/views/Finance/Index.vue';
import Campaigns from '@/views/Campaigns/Index.vue';
import NewAdvertisers from '@/views/AdvertisersMarketplace/Index.vue'
import logoPath from '@/assets/cropped-aff-space-logo.png'
import Unsubscribe from '../views/Unsubscribe.vue'
import EmailConfirmation from '@/views/Register/EmailConfirmation.vue'
import RegisterV2 from '@/views/Register/RegisterV2.vue'
import Postbacks from '@/views/Postbacks/Index.vue'
import Terms from '@/views/Terms/Index.vue'
import Help from '@/views/Help/Index.vue'
import PostbackSetupGuide from '@/views/Help/PostbackSetupGuide.vue'
import AdjustmentGuide from '@/views/Help/AdjustmentGuide.vue'
import AuditLog from '@/views/AuditLog/Index.vue'
import Tools from '@/views/Tools/Index.vue'
import SuperAdmin from '@/views/SuperAdmin/Index.vue'
const DEFAULT_TITLE = 'Space Affiliation'

export const savedRoute = ref(null);
const EARNINGS_ROUTES = new Set(['AdvertiserEarnings', 'SiteEarnings']);

const routes = [
  { path: '/', name: 'Home', component: Home, beforeEnter: isAllowed, meta: { title: 'Home' } },
  { path: '/register', name: 'RegisterV2', component: RegisterV2, beforeEnter: redirectIfLoggedIn, meta: { title: 'Register' } },
  { path: '/emailConfirmation', name: 'EmailConfirmation', component: EmailConfirmation, beforeEnter: redirectIfLoggedIn, meta: { title: 'Email Confirmation' } },
  { path: '/login', name: 'Login', component: Login, beforeEnter: redirectIfLoggedIn, meta: { title: 'Login' } },
  { path: '/users', name: 'Users', component: Users, beforeEnter: adminOrSubAffiliateCheck, meta: { title: 'Users' } },
  { path: '/users/:id', name: 'UserDetails', component: UserDetails, props: true, beforeEnter: adminCheck, meta: { title: 'User Details' } },
  { path: '/forbidden', name: 'Forbidden', component: Forbidden, meta: { title: 'Forbidden' } },
  { path: '/voonixAdvertisers', name: 'VoonixAdvertisers', component: VoonixAdvertisers, beforeEnter: adminCheck, meta: { title: 'Voonix Advertisers' } },
  { path: '/advertisers', name: 'Advertisers', component: Advertisers, beforeEnter: adminCheck, meta: { title: 'Advertisers' } },
  { path: '/advertisersV2', name: 'NewAdvertisers', component: NewAdvertisers, beforeEnter: combineGuards(isAllowed, isApproved), meta: { title: 'Advertisers catalog' } },
  { path: '/campaigns', name: 'Campaigns', component: Campaigns, beforeEnter: superAdminCheck, meta: { title: 'Campaigns' } },
  { path: '/sites', name: 'Sites', component: Site, beforeEnter: isAllowed, meta: { title: 'Sites' } },
  { path: '/postbacks', name: 'Postbacks', component: Postbacks, beforeEnter: isAllowed, meta: { title: 'Postbacks' } },
  { path: '/advertiserEarnings', name: 'AdvertiserEarnings', component: AdvertiserEarnings, beforeEnter: isAllowed, meta: { title: 'Advertiser Earnings' } },
  { path: '/siteEarnings', name: 'SiteEarnings', component: SiteEarnings, beforeEnter: isAllowed, meta: { title: 'Site Earnings' } },
  { path: '/settings', name: 'Settings', component: Settings, beforeEnter: isAllowed, meta: { title: 'Settings' } },
  { path: '/finance', name: 'Finance', component: Finance, beforeEnter: isAllowed, meta: { title: 'Finance' } },
  { path: '/reset-password/:token', name: 'ResetPassword', component: ResetPassword, beforeEnter: redirectIfLoggedIn, props: true, meta: { title: 'Reset Password' } },
  { path: '/terms', name: 'Terms', component: Terms, beforeEnter: isAllowed, meta: { title: 'Terms' } },
  { path: '/help', name: 'Help', component: Help, beforeEnter: superAdminCheck, meta: { title: 'Help' } },
  { path: '/help/postbacks-setup', name: 'PostbackSetupGuide', component: PostbackSetupGuide, beforeEnter: isAllowed, meta: { title: 'Setting up Postbacks' } },
  { path: '/help/adjustments', name: 'AdjustmentGuide', component: AdjustmentGuide, beforeEnter: adminCheck, meta: { title: 'Making an Adjustment' } },
  { path: '/auditLog', name: 'AuditLog', component: AuditLog, beforeEnter: adminCheck, meta: { title: 'Audit Log' } },
  { path: '/tools', name: 'Tools', component: Tools, beforeEnter: superAdminCheck, meta: { title: 'Tools' } },
  { path: '/superadmin', name: 'SuperAdmin', component: SuperAdmin, beforeEnter: superAdminCheck, meta: { title: 'Super Admin' } },
  //redirect
  {
    path: '/all-users', redirect: '/users'
  },
  //all 404s
  {
    path: '/:catchAll(.*)',
    name: 'Notfound',
    component: NotFound
  },  
  {
    path: '/unsubscribe/:token?',
    name: 'Unsubscribe',
    component: Unsubscribe,
    meta: { title: 'Unsubscribe' }
  }
]

const handleUnauthenticated = (to, next) => {
  if (!store.getters.isAuthenticated) {
    savedRoute.value = to.fullPath;
    next({ name: 'Login' });
  } else {
    next({ name: 'Forbidden' });
  }
};
async function adminCheck(to, from, next) {
  if (store.getters.isAuthenticated && store.getters.isAdmin) {
    next();
  } else {
    handleUnauthenticated(to, next);
  }
}

async function adminOrSubAffiliateCheck(to, from, next) {
  if (store.getters.isAuthenticated && (store.getters.isAdmin || store.getters.isSubAffiliate)) {
    next();
  } else {
    handleUnauthenticated(to, next);
  }
}

async function superAdminCheck(to, from, next) {
  if (store.getters.isAuthenticated && store.getters.isSuperAdmin) {
    next();
  } else {
    handleUnauthenticated(to, next);
  }
}

async function isAllowed(to, from, next) {
  if (await isLoggedIn()) {
    next();
  } else {
    savedRoute.value = to.fullPath;
    next({ name: 'Login' });
  }
}

async function isApproved(to, from, next) {
  if (store.getters.isApproved) {
    next();
  } else {
    next({ name: 'Forbidden' });
  }
}

async function isLoggedIn() {
  if (store.getters.isAuthenticated) {
    return true;
  } else {
    return false;
  }
}

async function redirectIfLoggedIn(to, from, next) {
  if (await isLoggedIn()) {
    next({ name: 'Home' });
  } else {
    next();
  }
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

function combineGuards(...handlers) {
  return async (to, from, next) => {
    for (const handler of handlers) {
      try {
        await new Promise((resolve, reject) => {
          handler(to, from, (result) => {
            if (result === false || typeof result === 'object') {
              reject(result);
            } else {
              resolve();
            }
          });
        });
      } catch (result) {
        next(result);
        return;
      }
    }
    next();
  };
}

// Global navigation guard
router.beforeEach(async (to, from, next) => {
    // Preserve date range when switching between earnings views
    if (EARNINGS_ROUTES.has(to.name) && EARNINGS_ROUTES.has(from.name)) {
      const hasDates = to.query.from && to.query.to;
      if (!hasDates && from.query.from && from.query.to) {
        return next({
          name: to.name,
          params: to.params,
          query: {
            ...to.query,
            from: from.query.from,
            to: from.query.to,
          },
        });
      }
    }
  // Only fetch the user state if it's not already fetched
  if (!store.getters.isAuthenticated) {
    await store.dispatch('getUser');
  }

  // Set title
  const title = to.meta.title
  if (title) {
    document.title = `${title} | ${DEFAULT_TITLE}`
  } else {
    document.title = DEFAULT_TITLE
  }

  next();
});

export default router